var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',{attrs:{"data-cy":"client-price"}},[_vm._v(_vm._s(_vm.$t('from'))+" "+_vm._s(_vm._f("price")(_vm.offer.price)))]),_vm._v(" "),_c('discount-label',{attrs:{"price":_vm.offer.price}}),_vm._v(" "),_c('commission-amount',{attrs:{"commission":_vm.offer.price.commission}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }